<template>
  <div>
    <v-img src="../assets/massagebprof2.jpg" alt="fizjoterapia" height="50vh"
      ><div class="display-2 color font-weight-bold mb-3 imageDiv">
        Oferta
      </div></v-img
    >
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          Zakres usług
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          Zakres usług
        </div>
      </v-col>
    </v-row>

    <v-row class="infor">
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <li class="listMargin">
          usprawnianie pacjentów po urazach ortopedycznych,
        </li>
        <li class="listMargin">
          leczenie dolegliwości bólowych kręgosłupa i stawów obwodowych,
        </li>
        <li class="listMargin">
          dyskopatia, kręgozmyk, zaburzenia posturalne,
        </li>
        <li class="listMargin">dysfunkcje narządu ruchu,</li>
        <li class="listMargin">stany przeciążeniowe mięśni i stawów,</li>
        <li class="listMargin">wady postawy ciała,</li>
        <li class="listMargin">urazy i kontuzje,</li>
        <li class="listMargin">refluks, zaburzenia odżywiania,</li>
        <li class="listMargin">terapia narządu wzroku,</li>
        <li class="listMargin">leczenie stawów skroniowo-żuchwowych,</li>
        <li class="listMargin">
          bóle głowy, migreny, nerwobóle, zawroty głowy,
        </li>
        <li class="listMargin">
          bezsenność, zaburzenia snu, chroniczne zmęczenie,
        </li>
        <li class="listMargin">terapia blizn,</li>
        <li class="listMargin">drenaż limfatyczny.</li>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <li class="listMargin">
          usprawnianie pacjentów po urazach ortopedycznych,
        </li>
        <li class="listMargin">
          leczenie dolegliwości bólowych kręgosłupa i stawów obwodowych,
        </li>
        <li class="listMargin">
          dyskopatia, kręgozmyk, zaburzenia posturalne,
        </li>
        <li class="listMargin">dysfunkcje narządu ruchu,</li>
        <li class="listMargin">stany przeciążeniowe mięśni i stawów,</li>
        <li class="listMargin">wady postawy ciała,</li>
        <li class="listMargin">urazy i kontuzje,</li>
        <li class="listMargin">refluks, zaburzenia odżywiania,</li>
        <li class="listMargin">terapia narządu wzroku,</li>
        <li class="listMargin">leczenie stawów skroniowo-żuchwowych,</li>
        <li class="listMargin">
          bóle głowy, migreny, nerwobóle, zawroty głowy,
        </li>
        <li class="listMargin">
          bezsenność, zaburzenia snu, chroniczne zmęczenie,
        </li>
        <li class="listMargin">terapia blizn,</li>
        <li class="listMargin">drenaż limfatyczny.</li>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.offers {
  margin-top: 12vh;
}
.listMargin {
  margin: 5px;
}
.imageDiv {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.color {
  text-shadow: 2px 2px #3e2723;
  color: #f5f5f5;
}
.infText {
  margin: auto;
}
.v-application .grey--text {
  color: #414149 !important;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.name {
  margin: 10px;
  color: #414149 !important;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
  margin-left: 4vw;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.textCenter {
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
}
h1 {
  margin: auto;
}
</style>
